import React from "react";
import "./style.css";

import { COR_DEFAULT, CampoObrigatorio, handleValidaCampos } from "../../pages/PesquisaSatisfacao";
import { Rating } from "react-simple-star-rating";

const LikerSatisfacao = ({ item, register, setValue, getValues }) => {
    const campo = `id_${item.codperguntaSatisfacao}_satisfacao`;

    function handleValue(data) {
        setValue(campo, data);
        handleValidaCampos(getValues(), item);
    }

    return (
        <div className="pesquisa-satisfacao-item-container" key={item.codperguntaSatisfacao}>
            <CampoObrigatorio id={`div_${item.codperguntaSatisfacao}_satisfacao`} />

            <span className="pesquisa-satisfacao-item-texto">{item.texto}</span>
            <span className="pesquisa-satisfacao-item-hint">{item.hint}</span>
            
            <Rating 
                fillColor={[COR_DEFAULT]}
                SVGstrokeColor={COR_DEFAULT}              
                SVGstorkeWidth={1}
                emptyColor={"#FFF"}
                size={40}
                iconsCount={item?.reduzida === "S" ? 4 : 5}
                showTooltip={true}
                tooltipStyle={{backgroundColor: COR_DEFAULT}}
                onClick={(data) => handleValue(data)}
                initialValue={0}
                tooltipDefaultText={"-"}
                SVGstyle={{marginRight: 5}}
                // initialValue={item?.respostaPadrao && item.respostaPadrao !== "-" ? parseInt(item.respostaPadrao) : 1}
            />

            <input style={{display: "none"}} defaultValue={''} {...register(campo, { required: false })}></input>
        </div>
    )
}

export default LikerSatisfacao;